import React               from 'react';
import Back                from '../../shared/back';
import LocaleString        from '../../shared/locale-string';
import { CloseCircleIcon } from '../../shared/icons/icons.jsx';

import './faqs.scss';

const Faqs = props => (
    <div className="faqs">

        <div className="content-container">
            <div className="title" >
                <Back className="back">
                    <CloseCircleIcon />
                </Back>
                <h1><LocaleString code="faqs.page.header" /></h1>
            </div>

            <LocaleString code="faqs.page.content" replaceOptions={ {
                userIdLabel: props.userIdLabel,
                verificationFieldLabel: props.verificationFieldLabel
            } } />

        </div>
    </div>
);

export default Faqs;
